<template>
  <div class="d-none">
    <div v-for="pos in coords" itemscope itemtype="http://schema.org/Place">
        <meta itemprop="name" :content="pos.company_name + ', ' + pos.city_name">
        <div itemprop="geo" itemscope itemtype="http://schema.org/GeoCoordinates">
            <meta itemprop="latitude" :content="pos.latitude">
            <meta itemprop="longitude" :content="pos.longitude">
        </div>
        <div itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
            <meta itemprop="telephone" :content="preperePhone(pos.phones) ">
            <meta itemprop="streetAddress" :content="pos.address">
            <!-- <meta itemprop="postalCode" content="117545"> -->
            <meta itemprop="addressLocality" :content="pos.city_name">
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ShemaOrgPlaces",
  props: { 
    coords: { 
      type: Array,
      required: true
    },
  },
  methods: {
		preperePhone(phone) { 
			if (phone) { 
				return phone.slice(0,7) + '-**-**'
			} else { 
				return '8-***-***-**-**'
			}
		},
  },
}

</script>
